module.exports = __webpack_public_path__ + "img/personal_active.74a7b76f.svg";